import { render, staticRenderFns } from "./PluginBuilder.vue?vue&type=template&id=6bb39a68&scoped=true"
import script from "./PluginBuilder.vue?vue&type=script&lang=js"
export * from "./PluginBuilder.vue?vue&type=script&lang=js"
import style0 from "./PluginBuilder.vue?vue&type=style&index=0&id=6bb39a68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb39a68",
  null
  
)

export default component.exports